<div class="mb-6 bg-blue-50 border border-blue-200 rounded-lg px-4 py-4 shadow-sm">
  <div class="flex mb-4">
    <div class="flex flex-col"></div>
    <h2 class="text-xl my-4 font-semibold"><span [innerHTML]="question.question | safeHtml"></span></h2>
  </div>

  <div class="space-y-4">
    <div *ngFor="let child of question.children; let i = index" class="">
      <app-question-block
        [question]="child"
        [index]="i + 1"
        [isMissing]="missingQuestionUuids.includes(child.uuid)"
        [missingQuestionUuids]="missingQuestionUuids"
        (answerSelected)="handleChildAnswer($event)"
        (answered)="answered.emit($event)"
      ></app-question-block>
    </div>
  </div>
</div>
